import api, { adminApi } from "./api";

// Public APIs (user)
export const getBoardsListApi = (params = {}) => {
  return api.get("/api/v1/boards/all/list", { params });
};

export const getRecommendBoardsApi = (limit = 3) => {
  return api.get("/api/v1/boards/recommend/random", { params: { limit } });
};

export const getLatestBoardsApi = (limit = 5) => {
  return api.get("/api/v1/boards/new", { params: { limit } });
};

export const getCommunityBoardsApi = (limit = 2) => {
  return api.get("/api/v1/boards/community", { params: { limit } });
};

export const getAllCommunityBoardsApi = () => {
  return api.get("/api/v1/boards/community/all");
};

export const getBoardByIdApi = (boardId) => {
  return api.get(`/api/v1/boards/${boardId}`);
};

// Admin APIs
export const getAdminBoardsApi = (params = {}) => {
  return adminApi.get("/api/v1/boards/board/list", { params });
};

export const getAdminBoardByIdApi = (boardId) => {
  return adminApi.get(`/api/v1/boards/admin/${boardId}`);
};

export const createBoardApi = (data) => {
  return adminApi.post("/api/v1/boards/create", data);
};

export const updateBoardApi = (boardId, data) => {
  return adminApi.put(`/api/v1/boards/${boardId}`, data);
};

export const deleteBoardApi = (boardId) => {
  return adminApi.delete(`/api/v1/boards/${boardId}`);
};
